import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/Home";
import Delivery from "@/pages/Delivery";
import Transfer from "@/pages/Transfer";
import Contact from "@/pages/Contact";
import OTCStore from "@/pages/OTCStore";
import Immunization from "@/pages/Immunization";
import VaccineDriveRequest from "@/pages/VaccineDriveRequest";
import HealthPartners from "@/pages/HealthPartners";
import HealthPartnerInfo from "@/pages/HealthPartnerInfo";
import Shipping from "@/pages/Shipping";
import TeleMedClinic from "@/pages/TeleMedClinic";
import TeleMedService from "@/pages/TeleMedService";
import PatientPortal from "@/pages/PatientPortal";
import AdminLogin from "@/pages/AdminLogin";
import AdminResetPassword from "@/pages/AdminResetPassword";

import AdminHome from "@/pages/admin/AdminHome";
import Orders from "@/pages/admin/Orders";
import Deliveries from "@/pages/admin/Deliveries";
import Inventory from "@/pages/admin/Inventory";
import OTCEditor from "@/pages/admin/OTCEditor";
import Rent from "@/pages/admin/Rent";
import CashAdvance from "@/pages/admin/CashAdvance";
import Income from "@/pages/admin/Income";
import Costs from "@/pages/admin/Costs";
import ProfitLoss from "@/pages/admin/ProfitLoss";
import AdminShipping from "@/pages/admin/AdminShipping";
import AdminTransfers from "@/pages/admin/AdminTransfers";
import AdminGlpLog from "@/pages/admin/AdminGlpLog";
import TimeClock from "@/pages/admin/TimeClock";
import Schedule from "@/pages/admin/Schedule";
import TimeOff from "@/pages/admin/TimeOff";
import StaffManagement from "@/pages/admin/StaffManagement";
import Payroll from "@/pages/admin/Payroll";
import PayPreview from "@/pages/admin/PayPreview";
import PayDayCalendar from "@/pages/admin/PayDayCalendar";
import OrderLog from "@/pages/admin/OrderLog";
import AdminVaccineDrives from "@/pages/admin/AdminVaccineDrives";
import Notes from "@/pages/admin/Notes";
import Tasks from "@/pages/admin/Tasks";

function AdminIndex() {
  const { user } = useAuth();
  if (user?.role === "worker") return <Navigate to="/admin/clock" replace />;
  return <AdminHome />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/delivery" element={<Delivery />} />
              <Route path="/transfer" element={<Transfer />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/otc-store" element={<OTCStore />} />
              <Route path="/immunizations" element={<Immunization />} />
              <Route path="/vaccine-drive" element={<VaccineDriveRequest />} />
              <Route path="/health-partners" element={<HealthPartners />} />
              <Route path="/partners" element={<HealthPartnerInfo />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/telemed" element={<TeleMedClinic />} />
              <Route path="/telemed/service/:slug" element={<TeleMedService />} />
              <Route path="/portal" element={<PatientPortal />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route
              path="/admin"
              element={<ProtectedRoute roles={["admin", "worker"]}><AdminLayout /></ProtectedRoute>}
            >
              <Route index element={<AdminIndex />} />
              <Route path="orders" element={<Orders />} />
              <Route path="order-log" element={<OrderLog />} />
              <Route path="deliveries" element={<Deliveries />} />
              <Route path="shipping" element={<AdminShipping />} />
              <Route path="transfers" element={<AdminTransfers />} />
              <Route path="glp-log" element={<AdminGlpLog />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="otc" element={<OTCEditor />} />
              <Route path="rent" element={<Rent />} />
              <Route path="cash-advance" element={<CashAdvance />} />
              <Route path="income" element={<Income />} />
              <Route path="costs" element={<Costs />} />
              <Route path="profit-loss" element={<ProfitLoss />} />
              <Route path="clock" element={<TimeClock />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="time-off" element={<TimeOff />} />
              <Route path="staff" element={<StaffManagement />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="pay-preview" element={<PayPreview />} />
              <Route path="pay-day-calendar" element={<PayDayCalendar />} />
              <Route path="vaccine-drives" element={<AdminVaccineDrives />} />
              <Route path="notes" element={<Notes />} />
              <Route path="tasks" element={<Tasks />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
